import {
  ProductNanoID,
  ProductPreviewModelFile,
  ProductPreviewModelName
} from '../../productsTypes';
import { GADataType } from '../../../../types';

import { useCurrentUser } from '../../../../auth/hooks/useAuth';

import { ModelViewerModalButton } from '../../../modelViewers/components/modalButtons/ModelViewerModalButton';

import { SimpleModalButtonDefaultProps } from '../../../../helpers/buttons/SimpleModalButton';

import { ProductsPermissions } from '../../productsConstants';

type ProductModelViewerModalButtonProps = Pick<
  SimpleModalButtonDefaultProps,
  | 'className'
  | 'title'
  | 'i18nTitle'
  | 'i18nText'
  | 'icon'
  | 'iconClassName'
  | 'tooltipPlacement'
  | 'tooltipI18nText'
  | 'modalSize'
> & {
  productNanoId?: ProductNanoID;
  previewModel?: {
    file: ProductPreviewModelFile;
    name: ProductPreviewModelName;
  };
};

function ProductModelViewerModalButton({
  className,
  dataGa,
  i18nText,
  i18nTitle,
  icon,
  iconClassName,
  modalSize,
  previewModel,
  productNanoId,
  title,
  tooltipI18nText,
  tooltipPlacement
}: ProductModelViewerModalButtonProps & GADataType) {
  const currentUser = useCurrentUser();

  return (
    <ModelViewerModalButton
      cameraControls
      className={className}
      dataGa={dataGa}
      i18nText={i18nText}
      i18nTitle={i18nTitle}
      icon={icon}
      iconClassName={iconClassName}
      modalSize={modalSize}
      model={previewModel}
      productNanoId={productNanoId}
      title={title}
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      withDownloadButton={currentUser.hasPermissions(
        ProductsPermissions.READ_PRODUCT_PREVIEW_MODEL_DOWNLOAD_BUTTON
      )}
    />
  );
}

export default ProductModelViewerModalButton;
